<div class="modal-body width-700">
  <div class="layout-auto-1-auto">
    <span class="modal-header">
       {{
          enumService.getEnumerationText(
            OEDetails.oe_enmName_OETyp,
            OEDetails.oe_enmIdent_OETyp
           ) === 'Person' ? 'Person' : 'Organisation'
       }} {{getGlobal('Create')}}
    </span>
    <div class="content">
      <app-exg-select-enumeration [caption]="enumService.getFieldCaption('OE', 'oe_enmIdent_OETyp')"
                                  [(value)]="OEDetails.oe_enmIdent_OETyp"
                                  enumerationName="OETyp"
      >
      </app-exg-select-enumeration>
      <ng-container *ngIf="enumService.getEnumerationText(
                              OEDetails.oe_enmName_OETyp,
                              OEDetails.oe_enmIdent_OETyp
                          ) === 'Person'">
        <app-exg-select-enumeration [caption]="enumService.getFieldCaption('OE', 'oe_enmIdent_AnredeTyp')"
                                    [(value)]="OEDetails.oe_enmIdent_AnredeTyp"
                                    enumerationName="AnredeTyp"
        >
        </app-exg-select-enumeration>
        <exg-input [(ngModel)]="OEDetails.oeNPraefix"
                   [caption]="enumService.getFieldCaption('OE', 'oeNPraefix')">
        </exg-input>
      </ng-container>
      <exg-input [(ngModel)]="OEDetails.oeName"
                 [caption]="enumService.getEnumerationText(
                                        OEDetails.oe_enmName_OETyp,
                                        OEDetails.oe_enmIdent_OETyp
                                    ) === 'Person' ?
                                        enumService.getFieldCaption('OE', 'oeName')
                                        : enumService.getFieldCaption('Organisation', 'BEZ')">
      </exg-input>
      <exg-input [(ngModel)]="OEDetails.oeEName"
                 [caption]="enumService.getFieldCaption('OE', 'oeEName')"
                 *ngIf="enumService.getEnumerationText(
                              OEDetails.oe_enmName_OETyp,
                              OEDetails.oe_enmIdent_OETyp
                          ) === 'Person'">
      </exg-input>
      <exg-input [(ngModel)]="OEDetails.oeNPraefix"
                 [caption]="enumService.getFieldCaption('Organisation', 'KBZ')"
                 *ngIf="enumService.getEnumerationText(
                              OEDetails.oe_enmName_OETyp,
                              OEDetails.oe_enmIdent_OETyp
                          ) !== 'Person'">
      </exg-input>
      <app-exg-select-enumeration [caption]="enumService.getFieldCaption('OE', 'oe_CrmRolle')"
                                  [(value)]="OEDetails.oe_CrmRolle"
                                  [enumerationName]="'CrmRolle' + (
                                                              enumService.getEnumerationText(
                                                                OEDetails.oe_enmName_OETyp,
                                                                OEDetails.oe_enmIdent_OETyp
                                                              ) === 'Person' ? 'Person' : 'Organisation')"
      >
      </app-exg-select-enumeration>
    </div>
    <div class="spawn-modal-actions typo-small">
      <button (click)="save()"
              class="md-btn">
	      {{getGlobal('Save')}}
      </button>
      <button (click)="close()" class="md-btn">
        {{getGlobal('Cancel')}}
      </button>
    </div>
  </div>
</div>
